import {
    isPlayerAction, 
    isRemovePlayerEvent,
    PlayerId,
    Projection,
    SharedGameState,
    useGameStore,
} from '@glark-newco/game-library';
import {shallow} from 'zustand/shallow';
import {AvatarInterface, blankAvatar} from '../hooks/useCreateAvatar';
import {isPlayerAvatarPayload} from '../SupplyChainPayloadTypes';

type AvatarMap = Record<PlayerId, AvatarInterface>;

export interface PlayerAvatarSlice extends SharedGameState {
    playerAvatars?: AvatarMap;
}

export const avatarProjection: Projection<PlayerAvatarSlice> = {
    name: 'avatarProjection',
    project: (state, newEvents) => {
        const avatars = {...(state.playerAvatars ?? {})};
        let modified = false;

        newEvents.forEach(ev => {
            // New avatar‑choice events
            if (isPlayerAction(ev) && isPlayerAvatarPayload(ev.payload)) {
                const pid = ev.playerId;
                if (!pid) throw new Error('Avatar event missing playerId');
                avatars[pid] = ev.payload.avatar;
                modified = true;
                
            } else if (isRemovePlayerEvent(ev)) {
                const pid = ev.removePlayerId;
                if (pid && avatars[pid] !== undefined) {
                    delete avatars[pid];
                    modified = true;
                }
            }
        });

        return modified ? {playerAvatars: avatars} : {};
    },
    // Reset to an empty map when the store is cleared (tests, reconnection, etc.)
    reset: () => ({playerAvatars: {}}),
};

export const usePlayerAvatars = () =>
    useGameStore((s:PlayerAvatarSlice) => s.playerAvatars) ?? {};

export const usePlayerAvatar = (playerId: PlayerId) => {
    return useGameStore(
        (s: PlayerAvatarSlice) => s.playerAvatars?.[playerId] ?? blankAvatar,
        shallow,
    );
};
